import { Injectable } from '@angular/core';
import Quill, { RangeStatic } from 'quill';
import { ClubPublicationService } from '../services/publication.service';

@Injectable({
    providedIn: 'root',
})
export class PublicationQuillEditorHelper {
    constructor(private readonly publicationService: ClubPublicationService) {}

    public readonly modulesForClubPosts = {
        toolbar: [
            ['bold', 'italic', 'underline', 'link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
        ],
        clipboard: {
            matchers: [
                [
                    'img',
                    (node: any) => {
                        const Delta = Quill.import('delta');
                        return new Delta().insert('');
                    },
                ],
                [
                    'p',
                    (node: any) => {
                        const Delta = Quill.import('delta');
                        return new Delta().insert(node.textContent + '\n');
                    },
                ],
                [
                    'br',
                    () => {
                        const Delta = Quill.import('delta');
                        return new Delta().insert('\n');
                    },
                ],
            ],
            matchVisual: false
        },
        keyboard: {
            bindings: [
                {
                    key: 13,
                    handler: (range: RangeStatic, context: any) => {
                        return !this.publicationService.isMentionOpened;
                    },
                },
            ],
        },
    };

    public readonly noToolbar = { toolbar: false };
}
